import { ensureBase64Padding } from "@utils/base64";

/**
 * Gets a coral ID using the same logic as useCoralStoryId.
 * This ensures consistency across all components that need to get coral IDs.
 *
 * Priority order:
 * 1. chorusId (if NEXT_PUBLIC_CORAL_LEGACY_ID is "true")
 * 2. chorusUuid (used on Duet The Verge)
 * 3. globalId with base64 padding (for new multi-community network)
 * 4. globalId (fallback)
 * 5. nodeId (final fallback)
 *
 * @param args - The coral ID arguments
 * @returns The coral ID to match with Coral
 */
export function getCoralIdFromNode(args: {
  chorusId?: number | null;
  chorusUuid?: string | null;
  globalId?: string | null;
  nodeId?: string;
}): string {
  const enableLegacyID = process.env.NEXT_PUBLIC_CORAL_LEGACY_ID === "true";
  return (
    // chorusId has been used on Chorus.
    (enableLegacyID && args.chorusId?.toString()) ||
    // chorusUuid has been used on Duet The Verge.
    args.chorusUuid ||
    // New id we are using! Must be unique across sites in a multi community network.
    (args.globalId && ensureBase64Padding(args.globalId)) ||
    args.globalId ||
    // Fallback to nodeId if no other ID is available
    args.nodeId ||
    ""
  );
}
